export const selectCurrentOrganisationState = (state: any) =>
  state.directChildOrganisationAdministration.currentOrganisation;

export const selectHasParentOrganisationCapability = (state: any): boolean => {
  const currentOrganisation = selectCurrentOrganisationState(state);

  return (
    state.login.user?.role === 'hospital-admin' &&
    currentOrganisation.status === 'success' &&
    currentOrganisation.data?.canBeParent === true
  );
};

export const selectDirectChildOrganisationsState = (state: any) =>
  state.directChildOrganisationAdministration.directChildOrganisations;

export const selectDirectChildOrganisations = (state: any) => {
  const directChildOrganisations = selectDirectChildOrganisationsState(state);

  return directChildOrganisations.slugs.map(
    (slug: string) => directChildOrganisations.bySlug[slug],
  );
};

export const selectDirectChildOrganisation = (state: any, organisationSlug: string) => {
  const directChildOrganisations = selectDirectChildOrganisationsState(state);

  return {
    ...(directChildOrganisations.details[organisationSlug] || {
      status: 'idle',
      error: null,
    }),
    data: directChildOrganisations.bySlug[organisationSlug] || null,
  };
};

export const selectDirectChildOrganisationCreation = (state: any) =>
  state.directChildOrganisationAdministration.directChildOrganisationCreation;

export const selectDirectChildOrganisationUsersState = (state: any) =>
  state.directChildOrganisationAdministration.directChildOrganisationUsers;

export const selectDirectChildOrganisationUserInvitation = (state: any) =>
  state.directChildOrganisationAdministration.directChildOrganisationUserInvitation;

export const selectDirectChildOrganisationUserEdit = (
  state: any,
  organisationSlug: string,
  userId: number,
) =>
  state.directChildOrganisationAdministration.directChildOrganisationUserEdit.requests[
    organisationSlug
  ]?.[String(userId)] || { status: 'idle' };

export const selectDirectChildOrganisationUsers = (state: any) => {
  const users = selectDirectChildOrganisationUsersState(state);

  return users.organisationSlugs
    .reduce(
      (allUsers: any[], organisationSlug: string) => [
        ...allUsers,
        ...Object.values(users.byOrganisation[organisationSlug] || {}),
      ],
      [],
    )
    .sort((left: any, right: any) => {
      const leftName = `${left.firstName} ${left.lastName}`.trim();
      const rightName = `${right.firstName} ${right.lastName}`.trim();
      return leftName.localeCompare(rightName) || left.email.localeCompare(right.email);
    });
};

export const selectDirectChildOrganisationUserDetails = (
  state: any,
  organisationSlug: string,
  userId: number,
) => {
  const key = String(userId);
  const details = state.directChildOrganisationAdministration.directChildOrganisationUserDetails;

  return {
    ...(details.requests[organisationSlug]?.[key] || {
      status: 'idle',
      error: null,
    }),
    user:
      state.directChildOrganisationAdministration.directChildOrganisationUsers.byOrganisation[
        organisationSlug
      ]?.[key] || null,
    invitations: details.invitations[organisationSlug]?.[key] || {
      status: 'idle',
      items: [],
      error: null,
      resendStatus: 'idle',
    },
  };
};
